@use "../../styles/mixins/component-wrapper" as wrapper;

@include wrapper.layered-component {
  div {
    display: flex;
    height: var(--semantic-size-content-m);
    width: fit-content;
    padding: var(--badge-inset-vertical) var(--badge-inset-horizontal);
    font: var(--semantic-text-utility-default-s);
    font-style: normal;
    line-height: var(--semantic-line-height-utility-s);
    letter-spacing: var(--semantic-letter-spacing-utility-s);
    border-radius: var(--semantic-border-radius-round);

    /* "Character Badge" styling */
    &[data-length="0"],
    &[data-length="1"] {
      width: var(--semantic-size-content-m);
      padding: 0;
      justify-content: center;
      align-items: center;
    }

    &.yellow {
      color: var(--semantic-color-on-accent-subtle-yellow-resting);
      background-color: var(--semantic-color-accent-subtle-yellow-resting);

      &.attention {
        color: var(--semantic-color-on-accent-attention-resting);
        background-color: var(--semantic-color-accent-attention-yellow-resting);
      }
    }

    &.orange {
      color: var(--semantic-color-on-accent-subtle-orange-resting);
      background-color: var(--semantic-color-accent-subtle-orange-resting);

      &.attention {
        color: var(--semantic-color-on-accent-attention-resting);
        background-color: var(--semantic-color-accent-attention-orange-resting);
      }
    }

    &.red {
      color: var(--semantic-color-on-accent-subtle-red-resting);
      background-color: var(--semantic-color-accent-subtle-red-resting);

      &.attention {
        color: var(--semantic-color-on-accent-attention-resting);
        background-color: var(--semantic-color-accent-attention-red-resting);
      }
    }

    &.purple {
      color: var(--semantic-color-on-accent-subtle-purple-resting);
      background-color: var(--semantic-color-accent-subtle-purple-resting);

      &.attention {
        color: var(--semantic-color-on-accent-attention-resting);
        background-color: var(--semantic-color-accent-attention-purple-resting);
      }
    }

    &.blue {
      color: var(--semantic-color-on-accent-subtle-blue-resting);
      background-color: var(--semantic-color-accent-subtle-blue-resting);

      &.attention {
        color: var(--semantic-color-on-accent-attention-resting);
        background-color: var(--semantic-color-accent-attention-blue-resting);
      }
    }

    &.aqua {
      color: var(--semantic-color-on-accent-subtle-aqua-resting);
      background-color: var(--semantic-color-accent-subtle-aqua-resting);

      &.attention {
        color: var(--semantic-color-on-accent-attention-resting);
        background-color: var(--semantic-color-accent-attention-aqua-resting);
      }
    }

    &.teal {
      color: var(--semantic-color-on-accent-subtle-teal-resting);
      background-color: var(--semantic-color-accent-subtle-teal-resting);

      &.attention {
        color: var(--semantic-color-on-accent-attention-resting);
        background-color: var(--semantic-color-accent-attention-teal-resting);
      }
    }

    &.green {
      color: var(--semantic-color-on-accent-subtle-green-resting);
      background-color: var(--semantic-color-accent-subtle-green-resting);

      &.attention {
        color: var(--semantic-color-on-accent-attention-resting);
        background-color: var(--semantic-color-accent-attention-green-resting);
      }
    }

    &.gray {
      color: var(--semantic-color-on-accent-subtle-gray-resting);
      background: var(--semantic-color-accent-subtle-gray-resting);

      &.attention {
        color: var(--semantic-color-on-accent-attention-resting);
        background: var(--semantic-color-accent-attention-gray-resting);
      }
    }

    &.disabled {
      color: var(--semantic-color-on-accent-subtle-disabled);
      background: var(--semantic-color-accent-subtle-disabled);

      &.attention {
        color: var(--semantic-color-on-accent-attention-disabled);
        background: var(--semantic-color-accent-attention-disabled);
      }
    }
  }
}
